import React, { Component } from 'react';
import { connect } from 'react-redux';
import BoxInside from '../../../core/BoxInside';
import WithholdingFile from '../../../views/Employee/Withholding/WithholdingFile';

import { StyledWrapperWithholding } from './style';
import { getIrpfByDNI } from '../../../../utils/apiWithholding';
import { getUserDetailsById } from '../../../../utils/apiUser';
import { validateDNI } from '../../../../utils/validations';
import { getManagedUsers } from '../../../../utils/apiControlAccess';

class WithholdingFileWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: new URLSearchParams(this.props.location.search).get('year'),
      id: new URLSearchParams(this.props.location.search).get('id'),
      tokenMail: new URLSearchParams(this.props.location.search).get('token'),
      modalPassword: true,
      errorPassword: false,
      errorMessage: false,
      employeeSelected: {},
      listManagedUsers: [],
      pdf: ''
    };
  }

  componentDidMount() {
    const { roles } = this.props;
    const { id } = this.state;
    getUserDetailsById(id).then(user => {
      this.setState({
        employeeSelected: {
          text: `${user.userProfile.name} ${user.userProfile.lastname}`,
          value: user.userProfile.userId,
          password: user.userProfile.username
        }
      });
    });

    if (roles.includes('ROLE_ACCESS_MANAGER')) {
      getManagedUsers().then(users =>
        this.setState({
          listManagedUsers: users.map(user => ({
            text:
              (user.nombre ? `${user.nombre} ` : '') +
              (user.apellido1 ? `${user.apellido1} ` : '') +
              (user.apellido2 ? `${user.apellido2} ` : ''),
            value: user.idEmpleado
          }))
        })
      );
    }
  }

  onCheckPassword = nif => {
    if (validateDNI(nif)) {
      this.downloadCertificate(nif);
    } else {
      this.setState({
        errorPassword: true
      });
    }
  };

  downloadCertificate = nif => {
    const { id, year, tokenMail } = this.state;

    getIrpfByDNI(id, year, nif, tokenMail)
      .then(response => {
        const contentType = response.headers['content-type'];
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: contentType
          })
        );

        if (contentType === 'application/octet-stream') {
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'certificados.zip');
          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
          this.setState({
            errorPassword: false,
            modalPassword: false
          });
        } else {
          this.setState({
            errorPassword: false,
            modalPassword: false,
            pdf: url
          });
        }
      })
      .catch(error => {
        if (error.code === 403) {
          this.setState({
            errorPassword: true
          });
        } else if (error.code === 404) {
          this.setState({
            errorMessage: true
          });
        }
      });
  };

  render() {
    const {
      errorMessage,
      year,
      pdf,
      modalPassword,
      errorPassword,
      errorMessageText,
      employeeSelected,
      listManagedUsers
    } = this.state;
    return (
      <BoxInside>
        <StyledWrapperWithholding>
          <WithholdingFile
            year={year}
            pdf={pdf}
            errorMessage={errorMessage}
            errorMessageText={errorMessageText}
            errorPassword={errorPassword}
            listManagedUsers={listManagedUsers}
            modalPassword={modalPassword}
            employeeSelected={employeeSelected}
            checkPassword={value => this.onCheckPassword(value)}
            resetErrorMessage={() => this.setState({ errorPassword: false })}
            setEmployeeSelected={employee => this.setEmployeeSelected(employee)}
          />
        </StyledWrapperWithholding>
      </BoxInside>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  roles: user.user.roles,
  userId: user.user.userId,
  userName: `${user.user.name} ${user.user.lastname}`
});

export default connect(mapStateToProps)(WithholdingFileWrapper);
